import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Jumbotron } from "./migration";
import { certifications } from "../../editable-stuff/config";

const Certifications = () => {
  if (!certifications || !certifications.show) {
    return (
      <Jumbotron fluid id="certifications" className="bg-light m-0">
        <Container>
          <h2 className="display-4 pb-5 text-center">Certifications</h2>
          <p className="text-center">No certifications to display.</p>
        </Container>
      </Jumbotron>
    );
  }

  const items = certifications.data || [];

  const renderBadge = (item, idx) => {
    // support both string entries and object entries: { name, image, link }
    let name = "";
    let img = null;
    let link = null;
    let jsonObj = null;
    if (typeof item === "string") {
      name = item;
    } else if (typeof item === "object" && item !== null) {
      name = item.name || item.title || "";
      img = item.image || item.img || null;
      link = item.link || item.url || null;
      jsonObj = item.data || item.details || item.meta || item.json || null;
      // if image is actually an object (e.g., JSON badge), treat it as json
      if (!jsonObj && typeof img === "object") {
        jsonObj = img;
        img = null;
      }

      // treat explicit null `image: null` as an instruction to show the name in-badge
      var explicitNullImage = Object.prototype.hasOwnProperty.call(item, "image") && item.image === null;

      // infer name from JSON badge if missing
      if ((!name || name.trim() === "") && jsonObj) {
        if (jsonObj.name) name = jsonObj.name;
        else if (jsonObj.credentialSubject && jsonObj.credentialSubject.achievement && jsonObj.credentialSubject.achievement.name)
          name = jsonObj.credentialSubject.achievement.name;
      }
    }

    // initials fallback
    const initials = (name || "").split(" ").map(p => (p ? p[0] : "")).slice(0,2).join("").toUpperCase();

    // extract image URL from JSON badge if present
    const jsonImageUrl = jsonObj && jsonObj.image && (jsonObj.image.id || jsonObj.image.url || jsonObj.image.src);

    // inner component to handle image load errors per-badge
    const BadgeVisualInner = ({ src, jsonObjLocal, initialsLocal, nameLocal, explicitNull }) => {
      const [imgFailed, setImgFailed] = useState(false);

      // If the config explicitly set image: null, show the full name in bold inside the badge area
      if (explicitNull) {
        return (
          <div
            aria-hidden
            style={{ width: '100%', minHeight: 96, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, background: 'transparent', padding: '0 8px' }}
          >
            <strong style={{ textAlign: 'center' }}>{nameLocal}</strong>
          </div>
        );
      }

      if (src && !imgFailed) {
        return (
          <img
            src={src}
            alt={`${nameLocal} badge`}
            className="img-fluid"
            style={{ maxHeight: 110, objectFit: "contain", background: "transparent" }}
            onError={() => setImgFailed(true)}
          />
        );
      }

      if (jsonObjLocal && (!src || imgFailed)) {
        return (
          <pre
            style={{
              maxHeight: 110,
              overflow: "auto",
              margin: 0,
              padding: "8px 12px",
              whiteSpace: "pre-wrap",
              textAlign: "left",
              fontSize: 12,
              fontFamily: "SFMono-Regular, Menlo, Monaco, 'Roboto Mono', 'Courier New', monospace",
              background: "transparent",
              border: "none",
            }}
          >
            {JSON.stringify(jsonObjLocal, null, 2)}
          </pre>
        );
      }

      // fallback initials
      return (
        <div
          aria-hidden
          style={{ width: 96, height: 96, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, background: "transparent" }}
        >
          <span>{initialsLocal}</span>
        </div>
      );
    };

    const badgeVisual = (
      <div style={{ minHeight: 120, display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
        <BadgeVisualInner src={img || jsonImageUrl} jsonObjLocal={jsonObj} initialsLocal={initials} nameLocal={name} explicitNull={explicitNullImage} />
      </div>
    );

    // caption: hide if the badge area already displays the full name (no image/json)
    const displayNameInBadge = explicitNullImage || (!img && !jsonImageUrl && !jsonObj);
    const caption = !displayNameInBadge ? (
      <div className="text-center" style={{ background: "transparent", marginTop: 6 }}>
        <div style={{ fontSize: 16, fontWeight: 500, color: "inherit" }}>{name}</div>
      </div>
    ) : null;

    const content = (
      <div className="d-flex flex-column align-items-center justify-content-start" style={{ background: "transparent", padding: 8 }}>
        {badgeVisual}
        {caption}
      </div>
    );

    if (link) {
      return (
        <Col key={`cert-${idx}`} xs={12} sm={6} md={4} lg={3} className="mb-4">
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "inherit" }}
            aria-label={`${name} certificate link`}
          >
            {content}
          </a>
        </Col>
      );
    }

    return (
      <Col key={`cert-${idx}`} xs={12} sm={6} md={4} lg={3} className="mb-4">
        {content}
      </Col>
    );
  };

  return (
    <Jumbotron fluid id="certifications" className="bg-light m-0">
      <Container>
        <h2 className="display-4 pb-5 text-center">{certifications.heading}</h2>
        {items.length ? (
          <Row>
            {items.map((cert, idx) => renderBadge(cert, idx))}
          </Row>
        ) : (
          <p className="text-center">No certifications to display.</p>
        )}
      </Container>
    </Jumbotron>
  );
};

export default Certifications;
